const TrainingSession = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    className={className}
  >
    <path
      d="M32 16C35.3137 16 38 13.3137 38 10C38 6.68629 35.3137 4 32 4C28.6863 4 26 6.68629 26 10C26 13.3137 28.6863 16 32 16Z"
      fill="currentColor"
    />
    <path
      d="M13.4141 36.5859C12.6328 35.8047 11.3672 35.8047 10.5859 36.5859L4.58594 42.5859C3.80469 43.3672 3.80469 44.6328 4.58594 45.4141L10.5859 51.4141C10.9766 51.8047 11.4883 52 12 52C12.5117 52 13.0234 51.8047 13.4141 51.4141C14.1953 50.6328 14.1953 49.3672 13.4141 48.5859L8.82812 44L13.4141 39.4141C14.1953 38.6328 14.1953 37.3672 13.4141 36.5859Z"
      fill="currentColor"
    />
    <path
      d="M59.4141 42.5859L53.4141 36.5859C52.6328 35.8047 51.3672 35.8047 50.5859 36.5859C49.8047 37.3672 49.8047 38.6328 50.5859 39.4141L55.1719 44L50.5859 48.5859C49.8047 49.3672 49.8047 50.6328 50.5859 51.4141C50.9766 51.8047 51.4883 52 52 52C52.5117 52 53.0234 51.8047 53.4141 51.4141L59.4141 45.4141C60.1953 44.6328 60.1953 43.3672 59.4141 42.5859Z"
      fill="currentColor"
    />
    <path
      d="M32 28C23.1777 28 16 35.1777 16 44C16 52.8223 23.1777 60 32 60C40.8223 60 48 52.8223 48 44C48 35.1777 40.8223 28 32 28ZM39.707 37.707L32.707 44.707C32.5195 44.8945 32.2656 45 32 45H26C25.4473 45 25 44.5527 25 44C25 43.4473 25.4473 43 26 43H31.5859L38.293 36.293C38.6836 35.9023 39.3164 35.9023 39.707 36.293C40.0977 36.6836 40.0977 37.3164 39.707 37.707Z"
      fill="currentColor"
    />
    <path
      d="M42 29.0438V22C42 18.6914 39.3086 16 36 16H32H28C24.6914 16 22 18.6914 22 22V29.0438C24.8624 27.1235 28.3019 26 32 26C35.6981 26 39.1376 27.1235 42 29.0438Z"
      fill="currentColor"
    />
  </svg>
);

export default TrainingSession;
